<template>
    <span :class="['sim-count-indicator', {
              'sim-count-indicator--c-primary': color === 'primary',
              'sim-count-indicator--c-success': color === 'success',
          }]"
          aria-hidden="true"
    >
        {{ count }}
    </span>
</template>

<script lang="ts" setup>
const {
    count,
    color = 'primary',
} = defineProps<{
    count: number | null
    color?: 'text' | 'primary' | 'success'
}>()

</script>

<style lang="scss" scoped>
.sim-count-indicator {
    $font-size: 0.75rem;
    $vertical-padding: 0.25em;
    $horizontal-padding: 0.375em;

    display: inline-block;

    padding: 0 $horizontal-padding;

    font-size: $font-size;
    line-height: calc(2 * $vertical-padding + $font-size);
    min-width: calc(2 * $vertical-padding + $font-size);
    text-align: center;

    border-radius: 4rem;

    box-sizing: border-box;
}

.sim-count-indicator--c-primary {
    background-color: $sim-c-primary-800;
    color: white;
}

.sim-count-indicator--c-success {
    background-color: $sim-c-success-400;
    color: $sim-c-black;
}

</style>
